"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class ObjectUtils {
    static isExist(string) {
        return string !== null && string !== undefined && string !== '';
    }
    static isEmptyObject(object) {
        for (const prop in object) {
            if (Object.prototype.hasOwnProperty.call(object, prop))
                return false;
        }
        return JSON.stringify(object) === JSON.stringify({});
    }
    static deepCopy(object) {
        return JSON.parse(JSON.stringify(object));
    }
}
exports.default = ObjectUtils;
